// @flow

import ko from 'rgs-knockout';
import _ from 'lodash';
import type { Observable, ObservableArray, PureComputed } from 'rgs-knockout';
// input-radio
import { default as RadioTemplate } from './template.html';
import BaseViewModel from 'rgs-nfd-ui-kit/ko-components/tree/BaseViewModel';
import type { ElementContent } from 'app/v2/core/contracts/ko-component.flow';

export interface IRadioInputItem {
	inputValue: PureComputed<*>,
	inputName: PureComputed<string>,
	inputId: PureComputed<string>,
	inputTitle: PureComputed<string>,
	selectedValue: Observable<boolean | *>,
	isSelected: PureComputed<boolean>,
}

export const withRadioItem = (
	className: Class<*>,
): Class<*> & IRadioInputItem => (
	class RadioInputItem extends className implements IRadioInputItem {

		selectedValue = ko.observable(false).extend({ toFromJS: true });

		isSelected = ko.pureComputed(() => {
			const selectedValue = this.selectedValue();
			return selectedValue !== false && selectedValue !== undefined;
		});

		inputValue = ko.pureComputed(() => {
			console.error('must be implemented inputValue');
			return '';
		});

		inputTitle = ko.pureComputed(() => {
			console.error('must be implemented inputTitle');
			return '';
		});

		inputName = ko.pureComputed(() => {
			console.error('must be implemented inputName');
			return '';
		});

		inputId = ko.pureComputed(() => {
			console.error('must be implemented inputId');
			return '';
		});
	}
);

export type RadioInputOptions = {
	items: ObservableArray<RadioInputItem>,
	value: Observable<RadioInputItem>,
	onChange?: (RadioInputItem)=>void
}

export class RadioInput extends BaseViewModel {
	_options: RadioInputOptions;
	_elementContent: ElementContent;

	get items (): ObservableArray<RadioInputItem> {
		return this._options.items;
	}

	get value (): ObservableArray<RadioInputItem> {
		return this._options.value;
	}

	constructor (
		{ props: options }: { props: RadioInputOptions },
		elementContent: ElementContent,
	) {
		super(options, elementContent);

		this._options = _.defaults(options, {
			onChange: _.noop,
		});
	}

	onChange (currentItem: RadioInputItem) {
		return () => {
			this.items().forEach((item: RadioInputItem) => {
				if (currentItem.inputId() !== item.inputId()) {
					item.selectedValue(false);
				}
			});
			this.value(currentItem);
			this._options.onChange(currentItem);
		};
	}

	isHathTemplate (): boolean {
		return this.elementContent.templateNodes.length > 0;
	}
}

export const COMPONENTS_RADIO_NAME = 'input-radio';

export const COMPONENTS_RADIO_ENTITIES = [
	{
		name: COMPONENTS_RADIO_NAME,
		entity: RadioInput,
		template: RadioTemplate,
	},
];
